import script from "./MyDraft.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyDraft.vue?vue&type=script&setup=true&lang=ts"

import "./MyDraft.vue?vue&type=style&index=0&id=21c8286e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c8286e"]])

export default __exports__